<template>
    <div class="app-loading">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
    </div>
</template>

<script>
    export default {
        name: "AppLoading"
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-loading {
        position: relative;
        padding: $paddingMD 0;
        width: 100%;
        height: 60px;
        text-align: center;

        & > div {
            display: inline-block;
            margin: 0 3px;
            height: 100%;
            width: 4px;
            background-color: $componentHighLightColor;
            background-color: var(--componentHighLightColor);
            animation: stretch-delay 1.2s infinite ease-in-out;
            @include transition-colors;
        }

        .rect2 {
            animation-delay: -1.1s
        }

        .rect3 {
            animation-delay: -1s
        }

        .rect4 {
            animation-delay: -.9s
        }

        .rect5 {
            animation-delay: -.8s
        }
    }

    @keyframes stretch-delay {
        0%, 40%, to {
            transform: scaleY(.4)
        }
        20% {
            transform: scaleY(1)
        }
    }
</style>